import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bank',
  templateUrl: './icon-bank.component.html'
})
export class IconBankComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
